import { motion } from 'framer-motion'
import { useInView } from 'framer-motion'
import { useRef } from 'react'
import { Award, Users, Target, TrendingUp, Handshake } from 'lucide-react'

const About = () => {
  const ref = useRef(null)
  const inView = useInView(ref, { once: true, margin: '-100px' })

  const stats = [
    { icon: Award, value: '15+', label: 'Années d\'Expérience' },
    { icon: Target, value: '95%', label: 'Taux de Réussite' },
    { icon: TrendingUp, value: '20+', label: 'Programmes Innovants' }
  ]

  return (
    <section id="about" className="py-20 bg-white" ref={ref}>
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="section-title">À Propos de GENIUS CLUB</h2>
          <p className="section-subtitle max-w-3xl mx-auto">
            Un centre d'excellence dédié au développement du potentiel cognitif et à la réussite éducative
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-orange-500/20 to-blue-500/20 blur-2xl rounded-3xl"></div>
              <img 
                src="images/genuis.png" 
                alt="Centre GENIUS CLUB"
                className="relative rounded-2xl shadow-2xl w-full h-96 object-cover"
              />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="space-y-6"
          >
            <h3 className="text-3xl font-bold text-gradient-orange-red mb-4">Notre Mission</h3>
            <p className="text-gray-700 leading-relaxed">
              GENIUS CLUB est un centre éducatif innovant spécialisé dans le développement des capacités mentales et cognitives. Nous offrons des programmes uniques combinant mathématiques mentales, coaching en performance, et techniques de neurolearning pour maximiser le potentiel de chaque élève.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Notre approche pédagogique moderne intègre les dernières découvertes en neurosciences pour créer des méthodes d'apprentissage efficaces et durables. Nous croyons que chaque individu possède un génie intérieur qui ne demande qu'à être révélé.
            </p>
            <div className="flex flex-wrap gap-4 mt-6">
              <div className="flex items-center gap-2 bg-orange-500/10 px-4 py-2 rounded-lg border border-orange-500/20">
                <Award className="w-5 h-5 text-orange-500" />
                <span className="font-medium text-orange-600">Certifié Excellence</span>
              </div>
              <div className="flex items-center gap-2 bg-blue-500/10 px-4 py-2 rounded-lg border border-blue-500/20">
                <Target className="w-5 h-5 text-blue-500" />
                <span className="font-medium text-blue-600">Résultats Garantis</span>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Section Statistiques */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-20"
        >
          {stats.map((stat, i) => (
            <motion.div
              key={i}
              className="bg-gradient-to-br from-orange-500 to-red-500 p-6 rounded-xl text-center text-white card-hover shadow-lg shadow-orange-500/25"
              whileHover={{ scale: 1.05 }}
              transition={{ duration: 0.3 }}
            >
              <stat.icon className="w-12 h-12 mx-auto mb-4" />
              <div className="text-4xl font-bold mb-2">{stat.value}</div>
              <div className="text-sm opacity-90">{stat.label}</div>
            </motion.div>
          ))}
        </motion.div>

        {/* Section Partenaire Unique */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.8 }}
          className="text-center"
        >
          <div className="flex items-center justify-center gap-3 mb-8">
            <Handshake className="w-8 h-8 text-orange-500" />
            <h3 className="text-2xl font-bold text-gray-800">Notre Partenaire</h3>
            <Handshake className="w-8 h-8 text-blue-500" />
          </div>
          
          {/* Logo du partenaire */}
          <motion.div
            className="inline-block p-6 bg-gradient-to-r from-orange-50 to-blue-50 rounded-2xl shadow-lg border border-orange-100"
            whileHover={{ scale: 1.02 }}
            transition={{ duration: 0.3 }}
          >
            <img 
              src="/images/logo2.png" 
              alt="Logo Partenaire"
              className="h-40 object-contain"
            />
          </motion.div>
        </motion.div>
      </div>
    </section>
  )
}

export default About